import LanguageFileBengali from "@src/localization/bn.json";
import LanguageFileEnglish from "@src/localization/en.json";
import LanguageFileHindi from "@src/localization/hi.json";
import LanguageFileMarathi from "@src/localization/mr.json";
import LanguageFileTamil from "@src/localization/ta.json";
import LanguageFileTelugu from "@src/localization/te.json";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n.use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: false,
    resources: {
      en: {
        translation: LanguageFileEnglish
      },
      hi: {
        translation: LanguageFileHindi
      },
      bn: {
        translation: LanguageFileBengali
      },
      mr: {
        translation: LanguageFileMarathi
      },
      ta: {
        translation: LanguageFileTamil
      },
      te: {
        translation: LanguageFileTelugu
      }
    },
    detection: {
      order: ["queryString", "cookie"],
      caches: ["cookie"]
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;

